import React from 'react'
import Page from '../components/Page'
import { Button, Card, CardBody, CardHeader, Col, Label, Row, Table, Modal, ModalBody, ModalFooter, ModalHeader, Nav, NavItem, NavLink, TabContent, TabPane, Form, FormFeedback, FormGroup, FormText, Input } from 'reactstrap'
import axios from '../utils/posAxios'
import StorageService from '../services/StorageService'
import { MdCameraAlt, MdFace, MdDone, MdClear, MdCreate, MdAdd } from 'react-icons/md'
import { BsPlusSquareFill } from 'react-icons/bs'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { Redirect } from 'react-router'
import classnames from 'classnames'
import PosDeliveryCollectionForm from '../components/PosDeliveryCollectionForm'
import { IconContext } from 'react-icons/lib'

class PosDeliveryCollectionTable extends React.Component {
  _isMounted = true
  constructor(props) {
    super(props)
    this.state = {
      deliveryList: [],
      modal: false,
      confirmModal: false,
      id: '',
      name: '',
      shipping_code: '',
      location: '',
      shipping_type: '',
      country: '',
      ecart_country: [],
      fee: '',
      free_value: '',
      compare_value: '',
      selectedData: '',
      selectedCountry: '',
      selectedId: '',
      store_id: '',
    }
  }

  componentDidMount() {
    this.DeliveryCollection()
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  DeliveryCollection = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.props.data.store_id,
    }

    axios
      .post(url + ':3003/v1/order/delivery/pickaddress', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }

        if (this._isMounted) {
          this.setState({
            deliveryList: result.data,
            store_id: this.props.data.store_id,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  toggle = (action, id) => () => {
    return this.setState({
      modal: !this.state.modal,
      isEdit: id != undefined || (id != null && action == 'EDIT') ? true : false,
      selectedId: id != undefined || (id != null && action == 'EDIT') ? id : '',
    })
  }

  toggleConfirmModal =
    (name, id, country = null) =>
    () => {
      return this.setState({
        confirmModal: !this.state.confirmModal,
        selectedData: name,
        selectedId: id,
        selectedCountry: country,
      })
    }

  closeModal = (title, message, level, reload) => {
    this.notificationSystem.addNotification({
      title: title,
      message: message,
      level: level,
      position: 'br',
      autoDismiss: 2,
      dismissible: 'click',
    })

    this.setState({
      modal: false,
    })

    if (reload) {
      window.location.reload()
    } else {
      this.DeliveryCollection()
    }
  }

  delete = () => {
    const user = StorageService.getSession('user_info')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const comp = StorageService.getSession('selected_org')

    let data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.store_id,
      company_id: comp.CompanyID,
      id: this.state.selectedId,
      delete_by: user.email,
    }

    axios
      .post(url + ':3003/v1/order/delivery/pickaddress/delete', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.notificationSystem.addNotification({
            title: <MdClear />,
            message: result.message,
            level: 'error',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          })
          return
        }

        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: `Delivery Collection deleted successfully.`,
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        })
        this.setState({ confirmModal: false })
        this.DeliveryCollection()
      })
      .catch(error => {
        alert(error)
      })
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/" />
    }
    return (
      <>
        <NotificationSystem dismissible={false} ref={notificationSystem => (this.notificationSystem = notificationSystem)} style={NOTIFICATION_SYSTEM_STYLE} />
        <div className="text-right mb-3">
          <div className="ps-btn-group">
            <Button color="link" onClick={this.toggle('ADD', null)}>
              <IconContext.Provider value={{ color: '#2a2c6b' }}>
                <BsPlusSquareFill size={25} />
              </IconContext.Provider>
            </Button>
          </div>
        </div>
        <Table responsive hover className={`ps-table tb-col-8`}>
          <thead>
            <tr>
              <th>Name</th>
              <th>Company</th>
              <th>Contact</th>
              <th>Mobile</th>
              <th>Unit</th>
              <th>Postal Code</th>
              <th>Country</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {this.state.deliveryList.length < 1 && (
              <tr>
                <td colSpan="8">
                  <div className="ps-empty-data">
                    <div className="empty-content">
                      <MdCreate />
                      <h4>No data to show</h4>
                      <span>Click the 'Create' button to add new delivery collection</span>
                    </div>
                  </div>
                </td>
              </tr>
            )}

            {this.state.deliveryList.length > 0 &&
              this.state.deliveryList.map((item, index) => {
                return (
                  <tr key={item.id}>
                    <td>{item.pick_name}</td>
                    <td>{item.pick_company}</td>
                    <td>{item.pick_contact}</td>
                    <td>{item.pick_mobile}</td>
                    <td>{item.pick_unit}</td>
                    <td>{item.pick_code}</td>
                    <td>{item.pick_country}</td>
                    <td>
                      <div className="ps-action-button">
                        <Button className="theme-button theme-button-secondary" onClick={this.toggle('EDIT', item.id)}>
                          Edit
                        </Button>
                        <Button className="theme-button theme-button-primary-light" onClick={this.toggleConfirmModal(item.pick_name, item.id)}>
                          Delete
                        </Button>
                      </div>
                    </td>
                  </tr>
                )
              })}
          </tbody>
        </Table>
        <Modal isOpen={this.state.modal} toggle={this.toggle()} className={this.props.className} centered>
          <PosDeliveryCollectionForm history={this.props.history} onToggleModal={this.toggle} closeModal={this.closeModal} match={this.props.match} data={this.state} />
        </Modal>
        <Modal isOpen={this.state.confirmModal} toggle={this.toggleConfirmModal()} className={this.props.className} centered style={{ fontSize: '0.85rem' }}>
          <ModalHeader toggle={this.toggleConfirmModal()}>Delete Delivery Collection</ModalHeader>
          <ModalBody>
            <Row>
              <Col md={12}>
                <p>Are you sure you want to delete this item ?</p>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button className="theme-button theme-button-secondary" onClick={this.toggleConfirmModal()}>
              No
            </Button>
            <Button className="theme-button theme-button-primary" onClick={() => this.delete()}>
              Yes
            </Button>
          </ModalFooter>
        </Modal>
      </>
    )
  }
}

export default PosDeliveryCollectionTable
